import React, { useState } from 'react';
import './SupportForm.css';
import { FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

const SupportForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone_number: '',
    DOB: '',
    reference: '',
    facebook: '',
    instagram: '',
    advance_payment: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
 
    console.log(formData);
  };

  return (
    
    <div className="container-fluid bg-gradient">
        <div className='Contact'>
        <div className="top-left-button-container">
      <Link to="/" className="top-left-button">
        <FaArrowLeft />
      </Link>
    </div>

      </div>
      <div className="containerr py-5">
        <h1 className="text-center mb-5" >Be My Supporter</h1>
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <label htmlFor="fullName" className="form-label">Full Name</label>
              <input
                type="text"
                className="form-control"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="phone_number" className="form-label">Phone Number</label>
              <input
                type="text"
                className="form-control"
                id="phone_number"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="DOB" className="form-label">Date of Birth</label>
              <input
                type="date"
                className="form-control"
                id="DOB"
                name="DOB"
                value={formData.DOB}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="reference" className="form-label">Reference</label>
              <input
                type="text"
                className="form-control"
                id="reference"
                name="reference"
                value={formData.reference}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="facebook" className="form-label">Facebook</label>
              <input
                type="text"
                className="form-control"
                id="facebook"
                name="facebook"
                value={formData.facebook}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="instagram" className="form-label">Instagram</label>
              <input
                type="text"
                className="form-control"
                id="instagram"
                name="instagram"
                value={formData.instagram}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-check-label" htmlFor="advance_payment">
                Advance Payment ₹ 500
              </label> 
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="advance_payment"
                  name="advance_payment"
                  checked={formData.advance_payment}
                  onChange={handleChange}
                />
              </div>
            </div>
         
            <button type="submit" className="btn btn-dark w-100 fw-bold">
                Submit
              </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SupportForm;
